export function BUCommentEnable(business_unit) {
    let bu_keys = ['highways', 'gcc_digital_planning']
    return bu_keys.includes(business_unit)
}

export function BUArchiveReasonEnable(business_unit) {
    let bu_keys = ['power_t&d', 'highways', 'gcc_digital_planning']
    return bu_keys.includes(business_unit)
}